import { GET_SUPERVISION_SUMMARY_SUCCESS } from './supervision.types';

const initialState = {
    supervisionSummary: null,
};

export const supervisionReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SUPERVISION_SUMMARY_SUCCESS:
            return {
                ...state,
                supervisionSummary: action.payload,
            };
        default:
            return state;
    }
};
